module.exports = __webpack_public_path__ + "static/media/6.502f9c06.jpg";